import { Dispatch } from '@reduxjs/toolkit';
import axiosInstance, { ApiKeys, getApiUrl, logError } from '../../../utils/ApiHelper';
import { setAgentEscalationCount } from '@cp/src/reducers/commonSlice';

export const getReporteesWithAllocation =
  (agentReferenceId: string, countOfEscalationEnabled?: boolean) => (dispatch: Dispatch) => {
    if (!countOfEscalationEnabled) {
      return;
    }
    const url = getApiUrl(ApiKeys.ESCALATION_COUNT, { agentReferenceId });
    axiosInstance
      .get(url)
      .then(res => {
        if (res?.data) {
          dispatch(setAgentEscalationCount(res?.data?.count));
        }
      })
      .catch(err => {
        logError(err);
      });
  };
